/* eslint-disable camelcase */
import { formatDate, formatToDecimalValue } from 'shared/utils'
import HyvaIcon from './icons/hyva'
import PayloaderIcon from './icons/payloader'
import WheelLoaderIcon from './icons/wheelLoader'

/* eslint-disable no-useless-escape */
export const ONLY_NUMBER_REG_EXP = /^[0-9]*\.?[0-9]+$/
export const DECIMAL_NUMBER_REG_EXP = /^[0-9]\d*(\.\d+)?$/
export const NEW_PASSWORD_REG_EXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$/
export const EMAIL_REG_EXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
export const CONTACT_NUMBER_REG_EXP = /^[6789]\d{9}$/
export const GST_NUMBER_REG_EXP = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
export const ONLY_NUMBER_DEC_REG_EXP = /^\d*\.?\d*$/
// /^\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/

export const SITE_NAME = 'Coal Analytics'
export const REACT_APP_ENV = process.env.REACT_APP_ENV || 'production'
export const DOMAIN = process.env.REACT_APP_DOMAIN || 'http://localhost:3000'
export const S3_PREFIX = process.env.REACT_APP_S3_PREFIX || 'https://coalbkt.s3.ap-south-1.amazonaws.com/'
export const API_URL = process.env.REACT_APP_BASE_URL || 'https://coal-backend.lc.webdevprojects.cloud'

export const STATUS = {
  p: { label: 'Pending', value: 'p' },
  a: { label: 'Approve', value: 'a' },
  r: { label: 'Reject', value: 'r' }
}

export const ADMIN_LOGS_MODULE = {
  sb: 'Sub Admin',
  u: 'User',
  a: 'Auth'
}
export const ADMIN_LOGS_ACTION = {
  i: 'INSERT',
  d: 'DELETE',
  v: 'VIEW',
  u: 'UPDATE',
  a: 'APPROVE',
  m: 'MERGE',
  up: 'UPLOAD',
  l: 'LOGIN',
  lo: 'LOGOUT',
  r: 'REJECT',
  p: 'PUBLISH',
  ust: 'UPDATE_STATUS',
  vf: 'VERIFY'
}

// Updated permission data based on new backend structure
// Maps to sKey values from the backend
export const permissionData = {
  // Dashboard Permissions
  VIEW_DASHBOARD: 'DASHBOARD_MAIN',
  VIEW_PRODUCTION_DATA_ALL: 'PRODUCTION_DATA_ALL_COMPANIES',
  VIEW_KEY_METRICS: 'KEY_METRICS',

  // Operations Permissions
  VIEW_OPERATIONS: 'OPERATIONS_MAIN',
  VIEW_PRODUCTION_DATA: 'PRODUCTION_DATA',
  VIEW_PRODUCTION_TIPPERS: 'PRODUCTION_TIPPERS',
  VIEW_PRODUCTION_TIPPERS_BY_NO: 'PRODUCTION_TIPPERS_BY_TIPPER_NO',
  VIEW_PRODUCTION_PAYLOADERS: 'PRODUCTION_PAYLOADERS',
  VIEW_PRODUCTION_PAYLOADERS_BY_NO: 'PRODUCTION_TIPPERS_BY_PAYLOADER_NO',
  VIEW_EQUIPMENT_DEPLOYMENT: 'EQUIPMENT_DEPLOYMENT',
  VIEW_MANPOWER_DEPLOYMENT: 'MANPOWER_DEPLOYMENT',
  VIEW_COMPETITORS_DATA: 'COMPETITORS_DATA',

  // Daily Trips/Operations
  VIEW_DAILY_TRIP: 'OPERATIONS_MAIN',
  CREATE_DAILY_TRIP: 'OPERATIONS_MAIN',
  EDIT_DAILY_TRIP: 'OPERATIONS_MAIN',
  DELETE_DAILY_TRIP: 'OPERATIONS_MAIN',

  // Competitor Trips
  VIEW_COMPETITOR_TRIP: 'COMPETITORS_DATA',
  CREATE_COMPETITOR_TRIP: 'COMPETITORS_DATA',
  EDIT_COMPETITOR_TRIP: 'COMPETITORS_DATA',

  // Equipment Permissions
  VIEW_EQUIPMENT: 'EQUIPMENT_MAIN',
  VIEW_VEHICLE: 'VEHICLE_DETAILS',
  CREATE_VEHICLE: 'VEHICLE_DETAILS',
  EDIT_VEHICLE: 'VEHICLE_DETAILS',
  DELETE_VEHICLE: 'VEHICLE_DETAILS',
  VIEW_VEHICLE_TYPES: 'VEHICLE_DETAILS',
  CREATE_VEHICLE_TYPES: 'VEHICLE_DETAILS',
  EDIT_VEHICLE_TYPES: 'VEHICLE_DETAILS',
  DELETE_VEHICLE_TYPES: 'VEHICLE_DETAILS',

  // Equipment Renewals
  VIEW_OVERVIEW: 'RENEWALS',
  EDIT_OVERVIEW: 'RENEWALS',
  VIEW_RENEWALS_INSURANCE: 'RENEWALS_INSURANCE',
  VIEW_RENEWALS_FITNESS: 'RENEWALS_FITNESS',
  VIEW_RENEWALS_PUC: 'RENEWALS_PUC',
  VIEW_RENEWALS_PERMIT: 'RENEWALS_PERMIT',

  // HR & Admin Permissions
  VIEW_HR_ADMIN: 'HR_ADMIN_MAIN',
  VIEW_MANPOWER: 'EMPLOYEE_DETAILS_DRIVERS_OPERATORS',
  CREATE_MANPOWER: 'EMPLOYEE_DETAILS_DRIVERS_OPERATORS',
  EDIT_MANPOWER: 'EMPLOYEE_DETAILS_DRIVERS_OPERATORS',
  DELETE_MANPOWER: 'EMPLOYEE_DETAILS_DRIVERS_OPERATORS',
  GET_MANPOWER: 'EMPLOYEE_DETAILS_DRIVERS_OPERATORS',
  VIEW_MANPOWER_ALL: 'EMPLOYEE_DETAILS_ALL_OTHER',
  CREATE_MANPOWER_ALL: 'EMPLOYEE_DETAILS_ALL_OTHER',
  EDIT_MANPOWER_ALL: 'EMPLOYEE_DETAILS_ALL_OTHER',
  DELETE_MANPOWER_ALL: 'EMPLOYEE_DETAILS_ALL_OTHER',
  GET_MANPOWER_ALL: 'EMPLOYEE_DETAILS_ALL_OTHER',

  // Leave Management
  LIST_EMPLOYEE_LEAVE: 'LEAVE_MANAGEMENT',
  ADD_EMPLOYEE_LEAVE: 'LEAVE_MANAGEMENT',
  UPDATE_EMPLOYEE_LEAVE: 'LEAVE_MANAGEMENT',
  DELETE_EMPLOYEE_LEAVE: 'LEAVE_MANAGEMENT',
  GET_EMPLOYEE_LEAVE: 'LEAVE_MANAGEMENT',

  // HR Renewals
  VIEW_HR_RENEWALS: 'HR_RENEWALS',
  VIEW_DL_RENEWALS: 'RENEWALS_DL',
  CREATE_DL_RENEWALS: 'RENEWALS_DL',
  EDIT_DL_RENEWALS: 'RENEWALS_DL',
  DELETE_DL_RENEWALS: 'RENEWALS_DL',
  VIEW_VTC_RENEWALS: 'RENEWALS_VTC',
  VIEW_IME_RENEWALS: 'RENEWALS_IME',

  // Attendance
  VIEW_ATTENDANCE: 'HR_ADMIN_MAIN',
  CREATE_ATTENDANCE: 'HR_ADMIN_MAIN',
  EDIT_ATTENDANCE: 'HR_ADMIN_MAIN',

  // Workshop Permissions
  VIEW_WORKSHOP: 'WORKSHOP_MAIN',
  VIEW_WORK_SHOP: 'VEHICLE_SERVICE_LOG',
  CREATE_WORK_SHOP: 'VEHICLE_SERVICE_LOG',
  UPDATE_WORK_SHOP: 'VEHICLE_SERVICE_LOG',
  DELETE_WORK_SHOP: 'VEHICLE_SERVICE_LOG',
  GET_WORK_SHOP: 'VEHICLE_SERVICE_LOG',

  // Stores Permissions
  VIEW_STORES: 'STORES_MAIN',
  VIEW_INVENTORY: 'STOCK_IN_HAND',
  ADD_INVENTORY: 'STOCK_IN_HAND',
  UPDATE_INVENTORY: 'STOCK_IN_HAND',
  GET_INVENTORY: 'STOCK_IN_HAND',
  VIEW_STOCK_HISTORY: 'STOCK_IN_HAND',

  // Purchase Orders
  VIEW_PURCHASE_ORDER: 'PURCHASE_ORDERS',
  CREATE_PURCHASE_ORDER: 'PURCHASE_ORDERS',
  EDIT_PURCHASE_ORDER: 'PURCHASE_ORDERS',
  UPDATE_PURCHASE_ORDER: 'PURCHASE_ORDERS',
  GET_PURCHASE_ORDER: 'PURCHASE_ORDERS',
  DELETE_PURCHASE_ORDER: 'PURCHASE_ORDERS',

  // Stores Movement
  VIEW_STORES_RECEIVED: 'STORES_RECEIVED',
  VIEW_STORES_ISSUED: 'STORES_ISSUED',
  VIEW_STORES_RETURNED: 'STORES_RETURNED',
  VIEW_STOCK_ISSUE: 'STORES_ISSUED',
  LIST_INVENTORY_LOG: 'STORES_MAIN',

  // Stores Consumed
  VIEW_STORES_CONSUMED: 'STORES_CONSUMED_TIPPERS',
  VIEW_STORES_CONSUMED_TIPPERS: 'STORES_CONSUMED_TIPPERS',
  VIEW_STORES_CONSUMED_PAYLOADERS: 'STORES_CONSUMED_PAYLOADERS',
  VIEW_STORES_CONSUMED_OTHERS: 'STORES_CONSUMED_OTHER_EQUIPMENT',

  // Vendor & Categories
  VIEW_VENDOR: 'VENDOR_LIST',
  CREATE_VENDOR: 'VENDOR_LIST',
  EDIT_VENDOR: 'VENDOR_LIST',
  DELETE_VENDOR: 'VENDOR_LIST',

  VIEW_PART_CATEGORY: 'STOCK_CATEGORY',
  CREATE_PART_CATEGORY: 'STOCK_CATEGORY',
  EDIT_PART_CATEGORY: 'STOCK_CATEGORY',
  DELETE_PART_CATEGORY: 'STOCK_CATEGORY',
  VIEW_PARTS_CATEGORY: 'STOCK_CATEGORY',
  CREATE_PARTS_CATEGORY: 'STOCK_CATEGORY',
  EDIT_PARTS_CATEGORY: 'STOCK_CATEGORY',
  GET_PARTS_CATEGORY: 'STOCK_CATEGORY',

  // HSD & Lubes
  VIEW_HSD: 'HSD_CONSUMPTION',
  CREATE_HSD: 'HSD_CONSUMPTION',
  GET_HSD: 'HSD_CONSUMPTION',
  DELETE_HSD: 'HSD_CONSUMPTION',

  VIEW_LUBES: 'LUBES_CONSUMPTION',
  CREATE_LUBES: 'LUBES_CONSUMPTION',
  GET_LUBES: 'LUBES_CONSUMPTION',
  DELETE_LUBES: 'LUBES_CONSUMPTION',

  // Master Data Permissions
  VIEW_MASTER: 'MASTER_MAIN',
  VIEW_RATE_MANAGEMENT: 'MANAGE_RATES',
  CREATE_RATE_MANAGEMENT: 'MANAGE_RATES',
  EDIT_RATE_MANAGEMENT: 'MANAGE_RATES',
  GET_RATE_MANAGEMENT: 'MANAGE_RATES',
  DELETE_RATE_MANAGEMENT: 'MANAGE_RATES',

  VIEW_MANAGE_WORKSITE: 'MANAGE_WORKSITE_LOGS',
  CREATE_MANAGE_WORKSITE: 'MANAGE_WORKSITE_LOGS',
  EDIT_MANAGE_WORKSITE: 'MANAGE_WORKSITE_LOGS',

  VIEW_MANAGE_EQUIPMENT: 'MANAGE_EQUIPMENT',
  CREATE_MANAGE_EQUIPMENT: 'MANAGE_EQUIPMENT',
  EDIT_MANAGE_EQUIPMENT: 'MANAGE_EQUIPMENT',
  DELETE_MANAGE_EQUIPMENT: 'MANAGE_EQUIPMENT',

  VIEW_MANAGE_COMPANY: 'MANAGE_OWN_COMPANIES',
  CREATE_MANAGE_COMPANY: 'MANAGE_OWN_COMPANIES',
  EDIT_MANAGE_COMPANY: 'MANAGE_OWN_COMPANIES',
  DELETE_MANAGE_COMPANY: 'MANAGE_OWN_COMPANIES',

  VIEW_MANAGE_COMPETITOR: 'MANAGE_COMPETITION',
  CREATE_MANAGE_COMPETITOR: 'MANAGE_COMPETITION',
  EDIT_MANAGE_COMPETITOR: 'MANAGE_COMPETITION',
  GET_MANAGE_COMPETITOR: 'MANAGE_COMPETITION',
  DELETE_MANAGE_COMPETITOR: 'MANAGE_COMPETITION',

  VIEW_MANAGE_WORKSITE_SETTINGS: 'MANAGE_WORKSITE_LISTING',
  CREATE_MANAGE_WORKSITE_SETTINGS: 'MANAGE_WORKSITE_LISTING',
  EDIT_MANAGE_WORKSITE_SETTINGS: 'MANAGE_WORKSITE_LISTING',
  DELETE_MANAGE_WORKSITE_SETTINGS: 'MANAGE_WORKSITE_LISTING',

  VIEW_DOCUMENT_DIRECTORY: 'DOCUMENT_DIRECTORY',
  CREATE_DOCUMENT_DIRECTORY: 'DOCUMENT_DIRECTORY',
  EDIT_DOCUMENT_DIRECTORY: 'DOCUMENT_DIRECTORY',
  DELETE_DOCUMENT_DIRECTORY: 'DOCUMENT_DIRECTORY',

  VIEW_DESIGNATION: 'HR_ADMIN_MAIN',
  CREATE_DESIGNATION: 'HR_ADMIN_MAIN',
  GET_DESIGNATION: 'HR_ADMIN_MAIN',
  UPDATE_DESIGNATION: 'HR_ADMIN_MAIN',

  // Reports Permissions
  VIEW_REPORTS: 'REPORTS_MAIN',
  VIEW_LOGS: 'REPORTS_MAIN',

  // Settings Permissions
  VIEW_SETTINGS: 'SETTINGS_MAIN',
  VIEW_STAFF: 'SETTINGS_MAIN',
  CREATE_STAFF: 'SETTINGS_MAIN',
  EDIT_STAFF: 'SETTINGS_MAIN',
  GET_STAFF: 'SETTINGS_MAIN',
  DELETE_STAFF: 'SETTINGS_MAIN',

  VIEW_ROLES: 'SETTINGS_MAIN',
  CREATE_ROLES: 'SETTINGS_MAIN',
  EDIT_ROLES: 'SETTINGS_MAIN',
  DELETE_ROLES: 'SETTINGS_MAIN',

  VIEW_SUBADMIN: 'SETTINGS_MAIN',
  CREATE_SUBADMIN: 'SETTINGS_MAIN',
  EDIT_SUBADMIN: 'SETTINGS_MAIN',
  DELETE_SUBADMIN: 'SETTINGS_MAIN',

  VIEW_USER: 'SETTINGS_MAIN',
  CREATE_USER: 'SETTINGS_MAIN',
  EDIT_USER: 'SETTINGS_MAIN',
  DELETE_USER: 'SETTINGS_MAIN',

  VIEW_MY_PROFILE: 'SETTINGS_MAIN',
  CREATE_MY_PROFILE: 'SETTINGS_MAIN',
  EDIT_MY_PROFILE: 'SETTINGS_MAIN',
  DELETE_MY_PROFILE: 'SETTINGS_MAIN',

  VIEW_PASSWORD: 'SETTINGS_MAIN',
  CREATE_PASSWORD: 'SETTINGS_MAIN',
  EDIT_PASSWORD: 'SETTINGS_MAIN',
  DELETE_PASSWORD: 'SETTINGS_MAIN',

  VIEW_CONFIGURATION: 'SETTINGS_MAIN'
}

export const COMPANY_LIST = [
  { value: 'apple', label: 'Apple Inc.' },
  { value: 'google', label: 'Google LLC' },
  { value: 'microsoft', label: 'Microsoft Corporation' },
  { value: 'amazon', label: 'Amazon.com, Inc.' },
  { value: 'facebook', label: 'Meta Platforms, Inc.' },
  { value: 'tesla', label: 'Tesla, Inc.' },
  { value: 'netflix', label: 'Netflix, Inc.' },
  { value: 'oracle', label: 'Oracle Corporation' },
  { value: 'adobe', label: 'Adobe Inc.' },
  { value: 'ibm', label: 'IBM Corporation' }
]

export const WORKSITE_TYPES = [
  { value: 'FACE', label: 'FACE' },
  { value: 'SIDING', label: 'RAILWAY SIDING' },
  { value: 'STOCK', label: 'STOCK YARD' },
  { value: 'REJECT', label: 'REJECT' }
]
// ? Define mapping for each type
export const typeFieldMap = {
  puc: {
    sRegistrationNo: 'Registration No',
    sShortName: 'Company Name',
    dPUCValidity: 'PUC Validity'
  },
  fitness: {
    sShortName: 'Employee ID',
    sRegistrationNo: 'Registration No',
    dFitnessValidity: 'Fitness Validity'
  },
  insurance: {
    sShortName: 'Employee No',
    sRegistrationNo: 'Registration No',
    dInsuranceValidity: 'Insurance Validity',
    iCompanyId: 'Company Name'
  },
  dl: {
    sName: 'Employee Name',
    sFatherName: 'Father Name',
    sMobNum: 'Mobile Number',
    iCompanyId: 'Company Name'
  },
  vtc: {
    sName: 'Employee Name',
    sFatherName: 'Father Name',
    sMobNum: 'Mobile Number',
    iCompanyId: 'Company Name'
  },
  ime: {
    sName: 'Employee Name',
    sFatherName: 'Father Name',
    sMobNum: 'Mobile Number',
    sShortName: 'Company Name',
    iCompanyId: 'Company Name'
  }
}
export const fieldMap = {
  sName: 'Vendor Name',
  sEmail: 'Email',
  sGSTNo: 'GST Number',
  sMobileNo: 'Mobile Number',
  sAddress: 'Address'
  // ? Add more mappings as needed
}
// export const DESIGNATION_TYPES = [
//   { value: 'Accountant', label: 'Accountant' },
//   { value: 'Attendance Clerk', label: 'Attendance Clerk' },
//   { value: 'Auto Electrician', label: 'Auto Electrician' },
//   { value: 'Camper Driver', label: 'Camper Driver' },
//   { value: 'Denter', label: 'Denter' },
//   { value: 'General Manager', label: 'General Manager' },
//   { value: 'Helper', label: 'Helper' },
//   { value: 'L.M.V. Driver', label: 'L.M.V. Driver' },
//   { value: 'Leaf Spring Suspension', label: 'Leaf Spring Suspension' },
//   { value: 'Mess Cook', label: 'Mess Cook' },
//   { value: 'Mess Helper', label: 'Mess Helper' },
//   { value: 'Mess Incharge', label: 'Mess Incharge' },
//   { value: 'Pay Operator', label: 'Pay Operator' },
//   { value: 'Payloader Helper', label: 'Payloader Helper' },
//   { value: 'Payloader Operator', label: 'Payloader Operator' },
//   { value: 'Supervisor', label: 'Supervisor' },
//   { value: 'Tipper Driver', label: 'Tipper Driver' },
//   { value: 'Tipper Helper', label: 'Tipper Helper' },
//   { value: 'Tipper Mechanic', label: 'Tipper Mechanic' },
//   { value: 'Tyre Mechanic', label: 'Tyre Mechanic' },
//   { value: 'Welder', label: 'Welder' },
//   { value: 'Workshop Incharge', label: 'Workshop Incharge' },
//   { value: 'Workshop Helper', label: 'Workshop Helper' }
// ]

export const DESIGNATION_TYPES = [
  { label: 'All', value: '' },
  { label: 'Fuel Station Operator', value: 'Fuel Station Operator' },
  { label: 'Site Munshi', value: 'Site Munshi' },
  { label: 'Payloader Helper', value: 'Payloader Helper' },
  { label: 'Patta Mechanic', value: 'Patta Mechanic' },
  { label: 'Denter', value: 'Denter' },
  { label: 'Accountant', value: 'Accountant' },
  { label: 'Billing Clerk', value: 'Billing Clerk' },
  { label: 'Car Driver', value: 'Car Driver' },
  { label: 'Tipper Driver', value: 'Tipper Driver' },
  { label: 'Tipper Helper', value: 'Tipper Helper' },
  { label: 'Office Boy', value: 'Office Boy' },
  { label: 'Welder', value: 'Welder' },
  { label: 'Office Clerk', value: 'Office Clerk' },
  { label: 'Cook Helper', value: 'Cook Helper' },
  { label: 'MTK Clerk', value: 'MTK Clerk' },
  { label: 'Asst. Payloader Mechanic', value: 'Asst. Payloader Mechanic' },
  { label: 'Payloader Operator', value: 'Payloader Operator' },
  { label: 'Sr. Supervisor', value: 'Sr. Supervisor' },
  { label: 'Tipper Running Mechanic', value: 'Tipper Running Mechanic' },
  { label: 'Store Incharge', value: 'Store Incharge' },
  { label: 'Payloader Incharge', value: 'Payloader Incharge' },
  { label: 'Sr. Payloader Helper', value: 'Sr. Payloader Helper' },
  { label: 'Auto Electrician', value: 'Auto Electrician' },
  { label: 'Clerk', value: 'Clerk' },
  { label: 'Supervisor', value: 'Supervisor' },
  { label: 'Camper Driver', value: 'Camper Driver' },
  { label: 'Cook', value: 'Cook' },
  { label: 'Payloader Mechanic', value: 'Payloader Mechanic' },
  { label: 'Sr. Store Keeper', value: 'Sr. Store Keeper' },
  { label: 'General Manager', value: 'General Manager' },
  { label: 'Workshop Incharge', value: 'Workshop Incharge' }
]

export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'हिन्दी' }
]

export const DAY_FILTER = [
  { value: 'today', label: 'Today' },
  { value: 'past', label: 'Past Leaves' },
  { value: 'future', label: 'Future Leaves' }
]

export const SHIFTS = [
  { label: 'Shift A', value: 'Shift A' },
  { label: 'Shift B', value: 'Shift B' },
  { label: 'Shift C', value: 'Shift C' }
]

export const BLOODGROUPS = [
  { label: 'N/A', value: 'N/A' },
  { label: 'A+', value: 'A+' },
  { label: 'A-', value: 'A-' },
  { label: 'B+', value: 'B+' },
  { label: 'B-', value: 'B-' },
  { label: 'AB+', value: 'AB+' },
  { label: 'AB-', value: 'AB-' },
  { label: 'O+', value: 'O+' },
  { label: 'O-', value: 'O-' }
]

export const PARTCATEGORYTYPE = [
  { label: 'All', value: '' },
  { label: 'HSD and lubes', value: 'FUEL_LUBES' },
  { label: 'Spare parts', value: 'SPARE_PARTS' },
  { label: 'Tyres', value: 'TYRES' },
  { label: 'Battery', value: 'BATTERY' },
  { label: 'Scrap', value: 'SCRAP' }
]

export const COMPANYCATEGORY = [
  { label: 'TSL', value: 'TSL' },
  { label: 'VPL', value: 'VPL' }
]

export const SYMBOL = [
  { label: 'Unit', value: 'NOS' },
  { label: 'Piece', value: 'PCS' },
  { label: 'Liter', value: 'L' },
  { label: 'Meter', value: 'M' },
  { label: 'Set', value: 'SET' },
  { label: 'KG', value: 'KG' }
]

export const TAX_RATES = [
  { label: '0', value: '0' },
  { label: '5', value: '5' },
  { label: '12', value: '12' },
  { label: '18', value: '18' },
  { label: '28', value: '28' }
]

export const TYPE_OF_WORK_HEAD = [
  { label: 'Engine', value: 'Engine' },
  { label: 'Gear', value: 'Gear' },
  { label: 'Differential', value: 'Differential' },
  { label: 'Running', value: 'Running' },
  { label: 'Electrical', value: 'Electrical' },
  { label: 'Spring (Patta)', value: 'Spring (Patta)' },
  { label: 'Welding', value: 'Welding' },
  { label: 'Denting', value: 'Denting' },
  { label: 'Tyre Works', value: 'Tyre Works' },
  { label: 'Hydraulic line', value: 'Hydraulic line' },
  { label: 'Transmission line', value: 'Transmission line' },
  { label: 'Engine Oil Change', value: 'Engine Oil Change' },
  { label: 'Gear Oil Change', value: 'Gear Oil Change' },
  { label: 'Crown Oil Change', value: 'Crown Oil Change' },
  { label: 'Hydraulic Oil Change', value: 'Hydraulic Oil Change' },
  { label: 'Transmission Oil Change', value: 'Transmission Oil Change' },
  { label: 'Coolant Change', value: 'Coolant Change' },
  { label: 'Engine Oil TOP-UP', value: 'Engine Oil TOP-UP' },
  { label: 'Gear Oil TOP-UP', value: 'Gear Oil TOP-UP' },
  { label: 'Crown Oil TOP-UP', value: 'Crown Oil TOP-UP' },
  { label: 'Hydraulic Oil TOP-UP', value: 'Hydraulic Oil TOP-UP' },
  { label: 'Transmission Oil TOP-UP', value: 'Transmission Oil TOP-UP' },
  { label: 'Full Hub Greasing', value: 'Full Hub Greasing' }
]

export const WORK_ORDER_TYPES = [
  { label: 'Breakdown', value: 'BREAKDOWN' },
  { label: 'Maintenance', value: 'MAINTENANCE' }
]

export const MOVEMENT_TYPES = [
  { value: '', label: 'All' },
  { value: 'RECEIVE', label: 'In' },
  { value: 'ISSUE', label: 'Out' }
]

export const RENEWALS = [
  { value: 'nDL', label: 'dLRenewal', type: 'dl' },
  { value: 'nIME', label: 'imePending', type: 'ime' },
  { value: 'nVT', label: 'vtcIncomplete', type: 'vtc' }
]

export const DESIGNATION_CATEGORIES = [
  { value: 'OPERATORS', label: 'Operators' },
  { value: 'MECHANIC', label: 'Mechanic' },
  { value: 'WORKSHOP_HELPER', label: 'Workshop Helper' },
  { value: 'CLERK', label: 'Clerk' },
  { value: 'SUPERVISOR', label: 'Supervisor' },
  { value: 'COOK', label: 'Cook' },
  { value: 'MANAGER', label: 'Manager' },
  { value: 'SUPPORT', label: 'Support' }
]

export const MENU = ['view', 'edit', 'restore', 'updateOrderStatus', 'received', 'cancelled', 'delete']

export const STATUS_MAP = {
  P: { text: 'pending', className: 'text-blue-700 bg-blue-50' },
  PF: { text: 'partlyFulfilled', className: 'text-warning-700 bg-warning-50' },
  CMP: { text: 'completed', className: 'text-success-700 bg-success-50' },
  CNCL: { text: 'cancelled', className: 'text-error-700 bg-error-50' }
}

export const ORDER_STATUS = [
  { label: 'All', value: '' },
  { label: 'Pending', value: 'P' },
  { label: 'Partly Fulfilled', value: 'PF' },
  { label: 'Completed', value: 'CMP' },
  { label: 'Cancelled', value: 'CNCL' }
]
export const PUNCH_OPT = [
  { value: 'all', label: 'All' },
  { value: true, label: 'Time-In' },
  { value: false, label: 'Time-Out' }
]

export const ICONS_MAP = {
  HYVA: <HyvaIcon />,
  PAYLOADER: <PayloaderIcon />,
  WHEEL_LOADER: <WheelLoaderIcon />
}

export const DFLT_WORKSHOP = {
  start: 0,
  limit: 10,
  active: true,
  dateFrom: '',
  dateTo: '',
  aVehicleType: [],
  aMechanicId: [],
  aDriverId: [],
  aVehicleId: [],
  aHelperId: [],
  aWorkOrderType: [],
  iCompanyId: [],
  search: ''
}

export const DFLT_RECEVIED = {
  newParts: {
    sInvoiceNo: '',
    eType: true,
    iBillCompanyId: '',
    dInvoiceDate: new Date()
  },
  repairedParts: {
    sInvoiceNo: '',
    eType: true,
    iBillCompanyId: '',
    dInvoiceDate: new Date()
  },
  aParts: []
}

export const CSTM_FORMAT_OPT_LBL = (option, { context }) => {
  if (context === 'value') return <p>{option?.sName}</p>

  const stockLevels = [
    { limit: 0, status: 'Out of Stock', color: 'text-red-500' },
    { limit: 10, status: 'Low Stock', color: 'text-warning-500' }
  ]

  const { status, color } = stockLevels.find(({ limit }) => option?.nQuantity <= limit) || {
    status: 'In Stock',
    color: 'text-success-500'
  }

  return (
    <div className="flex justify-between w-full">
      <div>
        <strong>{option?.sName}</strong>
        <div className="text-gray-500">
          <span className={`font-semibold ${color}`}>{option?.nQuantity} </span>
          {status}
        </div>
      </div>
      <div className="text-right">
        <strong>Rs. {option?.nCurrentRate || 0}</strong>
        <div className="text-xs text-gray-500">{option?.sSymbol}</div>
      </div>
    </div>
  )
}

export const LEAVE_TABS = [
  { name: 'current', value: 'today' },
  { name: 'historical', value: 'past' },
  { name: 'upcoming', value: 'future' }
]

export const DFLT_TRIPS_PAYLOAD = {
  dDate: formatDate(new Date(), 'YYYY-MM-DD'),
  iShiftId: []
}

export const DFLT_PAYLOADERS_PAYLOAD = {
  dDate: formatDate(new Date(), 'YYYY-MM-DD'),
  iShiftId: []
}

export const DFLT_TRIPS_FORM = {
  dDate: new Date(),
  // iShiftId: { label: 'All', value: '' },
  drivers: {},
  vehicles: [],
  worksiteData: [
    {
      oSiteFrom: '',
      oSiteTo: '',
      oFaceLead: '',
      oSurfaceLead: '',
      oTrip: '',
      iVehicleId: '',
      iEmployee: ''
    }
  ],
  tripsData: []
}
export const DFLT_PART_ISSUE = {
  aSpareParts: [],
  aOutSource: [],
  sPONotes: null,
  aInternalVoucherNo: [],
  iVehicleId: null,
  date: new Date()
}

export const DFLT_SCRAP_PART = {
  aSpareParts: [],
  aOutSource: [],
  sPONotes: '',
  iInventoryId: ''
}

export const DFLT_PART_APPEND = {
  iInventoryId: null,
  nAmount: '',
  nQuantity: 1,
  nTaxRate: ''
}

export const DFLT_OUTSOURCE_PART_APPEND = {
  iOutSourceSiteId: '',
  nAmount: '',
  nQuantity: '',
  sDescription: ''
}

export const CSTM_FRMT_OPT_LBL = (option, { context }) => {
  if (context === 'value') return <p>{option?.sName || option?.label}</p>

  return (
    <div className="flex flex-wrap justify-between items-center w-full">
      <div className="text-md font-medium flex-shrink-0">{option?.sName || option?.label}</div>
      <div className="text-sm font-normal flex-shrink-0">{formatDate(new Date(option?.dPunchIn), 'MMM DD, YYYY  hh:mm A')}</div>
    </div>
  )
}

export const CUST_FRMT_OPT_LBL = (option, { context }) => {
  if (context === 'value') return <p>{option?.sName}</p>

  const stockLevels = [
    { limit: 0, status: 'Out of Stock', color: 'text-red-500' },
    { limit: 10, status: 'Low Stock', color: 'text-warning-500' }
  ]

  const { status, color } = stockLevels.find(({ limit }) => option?.nQuantity <= limit) || {
    status: 'In Stock',
    color: 'text-success-500'
  }

  return (
    <div className="flex justify-between w-full">
      <div>
        <strong>{option?.sName}</strong>
        <div className="text-gray-500">
          <span className={`font-semibold ${color}`}>{formatToDecimalValue(option?.nQuantity)} </span>
          {status}
        </div>
      </div>
      <div className="text-right">
        <strong>Rs. {formatToDecimalValue(option?.nCurrentRate, 2) || 0}</strong>
        <div className="text-xs text-gray-500">{option?.sSymbol}</div>
      </div>
    </div>
  )
}

export const CUST_FRMT_OPT_LBL_IDENTITY = (option, { context }) => {
  if (context === 'value') return <p>{option?.sPartNo}</p>

  return (
    <div className="flex justify-between w-full">
      <div>
        <strong className="text-brand-700">{option?.sPartNo}</strong>
        <div className="text-gray-500">
          <span className={'font-semibold '}>{option?.sPartCompany} </span>
        </div>
      </div>
      <div className="text-right">
        <strong>{option?.sPartSize}</strong>
      </div>
    </div>
  )
}

export const E_SITE = [
  { label: 'Workshop', value: 'WORKSHOP' },
  { label: 'Site', value: 'SITE' }
]

export const BOOL_OPT = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
]

export const OVERVIEW_TABS = [
  { name: 'expired', value: 'expired' },
  { name: 'DueWithin60Days', value: 'dueWithInDays' },
  { name: 'valid', value: 'valid' },
  { name: 'pending', value: 'pending' }
]

export const SORT_OPTS_MANPOWER = [
  { label: 'Name (↑ A-Z)', value: { sort: 'sName', order: 'asc' } },
  { label: 'Name (↓ Z-A)', value: { sort: 'sName', order: 'dsc' } },
  { label: 'Joining Date (↑ 1-10)', value: { sort: 'dJoinDate', order: 'asc' } },
  { label: 'Joining Date (↓ 10-1)', value: { sort: 'dJoinDate', order: 'dsc' } },
  { label: 'ID Number (↑ 1-10)', value: { sort: 'nIdCard', order: 'asc' } },
  { label: 'ID Number (↓ 10-1)', value: { sort: 'nIdCard', order: 'dsc' } }
]

export const SORT_OPTS_VENDOR = [
  { label: 'Name (↑ A-Z)', value: { sort: 'sName', order: 'asc' } },
  { label: 'Name (↓ Z-A)', value: { sort: 'sName', order: 'dsc' } }
]

export const SORT_OPTS_INVETORY = [
  { label: 'Price (↑ Low to High)', value: { sort: 'nCurrentRate', order: 'asc' } },
  { label: 'Price (↓ High to Low)', value: { sort: 'nCurrentRate', order: 'dsc' } }
]

export const OVERTIME_OPTIONS = [
  { label: 'fullDay', value: 'FULL' },
  { label: 'firstHalf', value: 'FIRST_HALF' },
  { label: 'secondHalf', value: 'SECOND_HALF' }
]

export const COMPETITION_TABLE_COLUMNS_STOCK = [
  { label: 'company', value: 'sShortName' },
  { label: 'tippersOnRoad', value: 'nTipperOnRoad' },
  { label: 'shiftSmall', value: 'sShift' },
  {
    label: 'stockyard',
    children: [
      { label: 'noOfTrips', value: 'nTrip' },
      { label: 'tonnage', value: 'nWeight', formatTo: 'decimal' },
      { label: 'tonnage/trip', value: 'nTonnageAvg', formatTo: 'decimal' }
    ]
  },
  {
    label: 'rejectSmall',
    children: [
      { label: 'noOfTrips', value: 'nRejectedTrips' },
      { label: 'tonnage', value: 'nRejectedWeight', formatTo: 'decimal' },
      { label: 'tonnage/trip', value: 'nRejectedTonnageAvg', formatTo: 'decimal' }
    ]
  }
]
export const COMPETITION_TABLE_COLUMNS_SIDING = [
  { label: 'company', value: 'sShortName' },
  { label: 'tippersOnRoad', value: 'nTipperOnRoad' },
  { label: 'shiftSmall', value: 'sShift' },
  {
    label: 'siding',
    children: [
      { label: 'noOfTrips', value: 'nTrip' },
      { label: 'tonnage', value: 'nWeight', formatTo: 'decimal' },
      { label: 'tonnage/trip', value: 'nTonnageAvg', formatTo: 'decimal' }
    ]
  }
]

export const STATSBOARD_TABLE_COLUMNS = [
  { label: 'company', value: 'sCompanyName' },
  { label: 'siteFrom', value: 'sSiteFrom' },
  { label: 'siteTo', value: 'sSiteTo' },
  { label: 'trips', value: 'nTrip' },
  { label: 'quantity', value: 'nQuantity' },
  { label: 'tripAvg', value: 'nTripAvg' },
  { label: 'tonnAvg', value: 'nTonnAvg' },
  { label: 'lead', value: ['sFaceLeadKey', 'sSurfaceLeadKey'], separator: '' },
  { label: 'rate', value: 'nRate' },
  { label: 'amount', value: 'nAmount' }
]

export const STATSBOARD_STATS_LABELS = [
  { label: 'tipperOnRoad', value: 'nTipper' },
  { label: 'totalQuantity', value: 'nTotalQuantity' },
  { label: 'coalTransportAmount', value: 'nTransportAmount' },
  { label: 'coalLoadAmount', value: 'nLoadAmount' }
]

export const OVERVIEW_TABLE_COLUMNS_STOCK = [
  { label: 'shift', value: 'sName' },
  { label: 'coal', value: 'nTrip' },
  { label: 'rej', value: 'nRejectedTrips' },
  { label: 'Qty', value: 'nWeight' },
  { label: 'rejQty', value: 'nRejectedWeight' },
  { label: 'QtyAvg', value: 'nQtyAvg' },
  { label: 'R_T', value: 'nVehicleUsed' }
]

export const OVERVIEW_TABLE_COLUMNS_SIDING = [
  { label: 'shift', value: 'sName' },
  { label: 'coal', value: 'nTrip' },
  { label: 'Qty', value: 'nWeight' },
  { label: 'QtyAvg', value: 'nQtyAvg' }
]

export const DATE_RANGE_OPTIONS = [
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Today', value: 'today' },
  { label: 'Last 7 days', value: '7' },
  { label: 'Last 15 days', value: '15' },
  { label: 'Last 30 days', value: '30' },
  { label: 'Custom Range', value: 'custom' }
]

export const DYNAMIC_FILTER_DATE_OPTIONS = [
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last 7 days', value: '7' },
  { label: 'Last 15 days', value: '15' },
  { label: 'Last 30 days', value: '30' },
  { label: 'Custom Range', value: 'custom' }
]

// export const DFLT_MANPOWER_PAYLOAD = {
//   start: 0,
//   limit: 10,
//   search: '',
//   designation: [],
//   companyId: [],
//   eStatus: undefined,
//   sort: undefined,
//   order: undefined
// }

const reportsData = {
  'store-workshop': [
    {
      id: 'mis-workshop',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' }
      ],
      columns: [
        { name: 'sno', label: 'S. No' },
        { name: 'dDate', label: 'Date' },
        { name: 'sCompanyName', label: 'Company Name' },
        { name: 'sRegistrationNo', label: 'Tipper No.' },
        { name: 'dPunchIn', label: 'In Time' },
        { name: 'dPunchOut', label: 'Out Time' },
        { name: 'sTotalTime', label: 'Total Time' },
        { name: 'sDriverName', label: 'Driver Name' },
        { name: 'sHelperName', label: 'Helper' },
        { name: 'sMechanicName', label: 'Mechanic Name' },
        { name: 'eKindFault', label: 'Type of Fault' },
        { name: 'eSite', label: 'Location' },
        { name: 'eWorkOrderType', label: 'Service' },
        { name: 'nTotalAmount', label: 'Total Amount (Rs.)' },
        { name: 'sFinalNote', label: 'Details of Work Done' },
        { name: 'sCreatedByName', label: 'Work Order Created By' }
      ],
      slug: 'workshop'
    },
    {
      id: 'tipper-mis',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' },
        { name: 'tipperNo', label: 'selectEquipment', type: 'select', options: 'api:/vehicle/active-list/v1', required: true }
      ],
      columns: [
        { name: 'sno', label: 'S. No' },
        { name: 'dDate', label: 'Date' },
        { name: 'sCompanyName', label: 'Company Name' },
        { name: 'sRegistrationNo', label: 'Tipper No.' },
        { name: 'dPunchIn', label: 'In Time' },
        { name: 'dPunchOut', label: 'Out Time' },
        { name: 'sTotalTime', label: 'Total Time' },
        { name: 'sDriverName', label: 'Driver Name' },
        { name: 'sMechanicName', label: 'Mechanic Name' },
        { name: 'eSite', label: 'Location' },
        { name: 'eWorkOrderType', label: 'Service' },
        { name: 'nTotalAmount', label: 'Total Amount (Rs.)' },
        { name: 'sFinalNote', label: 'Details of Work Done' },
        { name: 'sCreatedByName', label: 'Work Order Created By' }
      ],
      slug: 'workshop'
    },
    {
      id: 'spares-tyres',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'sRegistrationNo', label: 'Tippers No./Payloader No.' },
        { name: 'nSparePartAmount', label: 'Spare Parts(Rs.)' },
        { name: 'nTyreAmount', label: 'Tyre (Rs.)' },
        { name: 'nOtherAmount', label: 'Other (Rs.)' },
        { name: 'nTotalAmount', label: 'Grand Total  (Rs.)' }
      ],
      slug: 'spares'
    },
    {
      id: 'tipper-spares-tyres',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' },
        { name: 'tipperNo', label: 'selectEquipment', type: 'select', options: 'api:/vehicle/active-list/v1', required: true }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'dDate', label: 'Date' },
        { name: 'sName', label: 'Part Name' },
        { name: 'nQuantity', label: 'Quantity' },
        { name: 'sSymbol', label: 'Symbol' },
        { name: 'nRate', label: 'Rate (Rs.)' },
        { name: 'nSparePartAmount', label: 'Spare cost (Rs.)' },
        { name: 'nTyreAmount', label: 'Tyre cost (Rs.)' },
        { name: 'nOtherAmount', label: 'Other (Rs.)' }
      ],
      slug: 'vehicle-spares'
    },
    {
      id: 'lubes-receive-stock',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' },
        { name: 'lube', label: 'selectLube', type: 'select', options: 'api:/inventory/list/lubes/v1' }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'sName', label: "Lube's Name" },
        { name: 'sParticular', label: 'Particulars' },
        { name: 'sCompany', label: 'Company' },
        { name: 'nReceive', label: 'Receive' },
        { name: 'nIssue', label: 'Issue' }
      ],
      slug: 'lubes'
    },
    {
      id: 'tipper-lubes-issue',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' },
        { name: 'tipperNo', label: 'selectEquipment', type: 'select', options: 'api:/vehicle/active-list/v1', required: true },
        { name: 'lube', label: 'selectLube', type: 'select', options: 'api:/inventory/list/lubes/v1' }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'dDate', label: 'Date' },
        { name: 'sName', label: "Lube's Name" },
        { name: 'sCompany', label: 'Company' },
        { name: 'sRegistrationNo', label: 'Tipper No.' },
        { name: 'nIssue', label: 'Issue' }
      ],
      slug: 'vehicle-lubes'
    },
    {
      id: 'vendor-lubes-receive',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' },
        { name: 'lube', label: 'selectLube', type: 'select', options: 'api:/inventory/list/lubes/v1' },
        { name: 'vendor', label: 'selectVendor', type: 'select', options: 'api:/vendor/list/v1', required: true, isInfiniteFetch: true }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'dDate', label: 'Date' },
        { name: 'sName', label: "Lube's Name" },
        { name: 'sCompany', label: 'Company' },
        { name: 'sVendor', label: 'Vendor Name' },
        { name: 'nReceive', label: 'Receive' }
      ],
      slug: 'vendor-lubes'
    },
    {
      id: 'hsd-received',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'dInvoiceDate', label: 'Invoice Date' },
        { name: 'dReceiveDate', label: 'Receive Date' },
        { name: 'sVendor', label: 'Description (Vendor Name)' },
        { name: 'nQuantity', label: 'Qty (ltr)' },
        { name: 'nRate', label: 'Rate (Rs.)' },
        { name: 'nCost', label: 'Cost (Rs.)' },
        { name: 'sInvoiceNo', label: 'Invoice No.' }
      ],
      slug: 'hsd-receive'
    },
    {
      id: 'vendor-hsd-received',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' },
        { name: 'vendor', label: 'selectVendor', type: 'select', options: 'api:/vendor/list/v1', required: true, isInfiniteFetch: true }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'dInvoiceDate', label: 'Invoice Date' },
        { name: 'dReceiveDate', label: 'Receive Date' },
        { name: 'sVendor', label: 'Description (Vendor Name)' },
        { name: 'nQuantity', label: 'Qty (ltr)' },
        { name: 'nRate', label: 'Rate (Rs.)' },
        { name: 'nCost', label: 'Cost (Rs.)' },
        { name: 'sInvoiceNo', label: 'Invoice No.' }
      ],
      slug: 'hsd-receive'
    },
    {
      id: 'vendor-spares-received',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' },
        { name: 'vendor', label: 'selectVendor', type: 'select', options: 'api:/vendor/list/v1', required: true, isInfiniteFetch: true },
        {
          name: 'category',
          label: 'selectCategory',
          type: 'multi-select',
          options: 'api:/parts-category/list-all/v1'
          // required: true
        }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'dReceivedDate', label: 'Received Date' },
        { name: 'sCompanyName', label: 'Company Name' },
        { name: 'sVendorName', label: 'Vendor Name' },
        { name: 'sInvoiceNo', label: 'Invoice No.' },
        { name: 'sName', label: 'Part Name' },
        { name: 'sPartNo', label: 'Part No.' },
        { name: 'sPartSize', label: 'Part Size' },
        { name: 'sPartCompany', label: 'Part Company' },
        { name: 'nQuantity', label: 'Quantity' },
        { name: 'nRate', label: 'Rate (Rs.)' },
        { name: 'nAmount', label: 'Amount (Rs.)' }
      ],
      slug: 'vendor-spares'
    },
    {
      id: 'spends-per-vendor',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' },
        {
          name: 'category',
          label: 'selectCategory',
          type: 'multi-select',
          options: 'api:/parts-category/list-all/v1'
          // required: true
        }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'sCompanyName', label: 'Company Name' },
        { name: 'sVendorName', label: 'Vendor Name' },
        { name: 'nTotalSpend', label: 'Total Spend (Rs.)' }
      ],
      slug: 'vendor-spends'
    },
    {
      id: 'quantity-purchased-item-wise',
      filters: [
        { name: 'dateRange', label: 'selectDateRange', type: 'dateRange', required: true },
        { name: 'company', label: 'selectCompanyPlaceholder', type: 'multi-select', options: 'api:/company/list/v1' },
        {
          name: 'category',
          label: 'selectCategory',
          type: 'multi-select',
          options: 'api:/parts-category/list-all/v1'
          // required: true
        }
      ],
      columns: [
        { name: 'sno', label: 'S. No.' },
        { name: 'sCompanyName', label: 'Company Name' },
        // { name: 'sCategoryType', label: 'Category Type' },
        { name: 'sItemName', label: 'Item Name' },
        { name: 'nTotalQuantity', label: 'Total Quantity' }
      ],
      slug: 'quantity-purchased-item-wise'
    }
  ]
}

export default reportsData

export const reportMap = new Map()

for (const [key, reports] of Object.entries(reportsData)) {
  for (const report of reports) {
    reportMap.set(report.id, { ...report, category: key })
  }
}

export const SORT_OPTS_LEAVE = [
  { label: 'Date (↑ From-To)', value: { sort: 'dStartDate', order: 'asc' } },
  { label: 'Date (↓ From-To)', value: { sort: 'dStartDate', order: 'dsc' } },
  { label: 'Name (↑ A-Z)', value: { sort: 'sEmployeeName', order: 'asc' } },
  { label: 'Name (↓ Z-A)', value: { sort: 'sEmployeeName', order: 'dsc' } }
]

export const SORT_OPTS_LEAVE_DETAILS = [
  { label: 'Date (↑ From-To)', value: { sort: 'dStartDate', order: 'asc' } },
  { label: 'Date (↓ From-To)', value: { sort: 'dStartDate', order: 'dsc' } }
]

export const OPERATIONS_COMPETITION_COLUMNS_STOCK = [
  { label: 'sno', value: '' },
  { label: 'company', value: 'sShortName' },
  {
    label: 'coalSmall',
    children: [
      { label: 'trips', value: 'nTrip' },
      { label: 'tonnage', value: 'nWeight', formatTo: 'decimal' }
    ]
  },
  {
    label: 'rejectSmall',
    children: [
      { label: 'trips', value: 'nRejectedTrips' },
      { label: 'tonnage', value: 'nRejectedWeight', formatTo: 'decimal' }
    ]
  },
  {
    label: 'total',
    children: [
      { label: 'trips', value: 'nTotalTrip' },
      { label: 'tonnage', value: 'nTotalWeight', formatTo: 'decimal' }
    ]
  },

  {
    label: 'averages',
    children: [
      { label: 'tippersOnRoad', value: 'nVehicleUsed' },
      { label: 'tripsPerTipper', value: 'nTripAvg', formatTo: 'decimal' },
      { label: 'tonnPerTrip', value: 'nTonnAvg', formatTo: 'decimal' }
    ]
  }
]

export const OPERATIONS_COMPETITION_COLUMNS_SIDING = [
  { label: 'sno', value: '' },
  { label: 'company', value: 'sShortName' },
  {
    label: 'total',
    children: [
      { label: 'trips', value: 'nTrip' },
      { label: 'tonnage', value: 'nWeight', formatTo: 'decimal' }
    ]
  },
  {
    label: 'averages',
    children: [
      { label: 'tippersOnRoad', value: 'nVehicleUsed' },
      { label: 'tripsPerTipper', value: 'nTripAvg', formatTo: 'decimal' },
      { label: 'tonnPerTrip', value: 'nTonnAvg', formatTo: 'decimal' }
    ]
  }
]

export const OPERATION_PRODUCTION_TRANSPORTATION_COLUMNS = [
  { label: 'company', value: 'sCompanyShortName' },
  { label: 'siteFrom', value: 'sSiteFrom' },
  { label: 'siteTo', value: 'sSiteTo' },
  { label: 'lead', value: ['sFaceLeadKey', 'sSurfaceLeadKey'] },
  { label: 'tippersOnRoad', value: 'nTipperOnRoad' },
  { label: 'noOfTrips', value: 'nTrip' },
  { label: 'tonnageTotal', value: 'nQuantity', formatTo: 'decimal' },
  { label: 'avgTripsPerTipper', value: 'nTripAvg', formatTo: 'decimal' },
  { label: 'avgTonnPerTrip', value: 'nTonnAvg', formatTo: 'decimal' },
  { label: 'rate', value: 'nRate', formatTo: 'decimal' },
  { label: 'amount', value: 'nAmount', formatTo: 'decimal' }
]

export const OPERATION_PRODUCTION_LOADING_COLUMNS = [
  { label: 'company', value: 'sCompanyShortName' },
  { label: 'nameOfFace', value: 'sSite' },
  { label: 'payloadersOnSite', value: 'nPayLoaderOnSite' },
  { label: 'noOfHoursWorked', value: 'nHour' },
  { label: 'tonnageTotal', value: 'nTonnage', formatTo: 'decimal' },
  { label: 'tonnHour', value: 'nTonnageHour', formatTo: 'decimal' },
  { label: 'rate', value: 'nRate', formatTo: 'decimal' },
  { label: 'amount', value: 'nAmount', formatTo: 'decimal' }
]

export const PRODUCTION_TIPPERS_COLUMNS = [
  { label: 'company', value: 'sShortName' },
  { label: 'tipperRegNo', value: 'sRegistrationNo' },
  { label: 'shiftSmall', value: 'sName' },
  {
    label: 'stockyard',
    children: [
      { label: 'noOfTrips', value: 'stockyardTrips' },
      { label: 'tonnage', value: 'stockyardTonnage', formatTo: 'decimal' },
      { label: 'tonnage/trip', value: 'stockyardTonnageAvg', formatTo: 'decimal' }
    ]
  },
  {
    label: 'rejectSmall',
    children: [
      { label: 'noOfTrips', value: 'rejectTrips' },
      { label: 'tonnage', value: 'rejectTonnage', formatTo: 'decimal' },
      { label: 'tonnage/trip', value: 'rejectTonnageAvg', formatTo: 'decimal' }
    ]
  },
  {
    label: 'siding',
    children: [
      { label: 'noOfTrips', value: 'sidingTrips' },
      { label: 'tonnage', value: 'sidingTonnage', formatTo: 'decimal' },
      { label: 'tonnage/trip', value: 'sidingTonnageAvg', formatTo: 'decimal' }
    ]
  },
  {
    label: 'totalSrs',
    children: [
      { label: 'noOfTrips', value: 'totalSrsTrips' },
      { label: 'tonnage', value: 'totalSrsTonnage', formatTo: 'decimal' },
      { label: 'tonnage/trip', value: 'totalSrsTonnageAvg', formatTo: 'decimal' }
    ]
  },
  { label: 'revenue', value: 'nAmount', formatTo: 'decimal' }
]
// Stores
export const STORE_TIPPERS_COLUMNS = [
  {
    label: 'tipperRegistrationNo',
    value: 'sRegistrationNo'
  },
  { label: 'company', value: 'sShortName' },
  {
    label: 'HSD',
    children: [
      { label: 'quantity', value: 'stockyardTrips' },
      { label: 'value', value: 'stockyardTonnage', formatTo: 'decimal' }
    ]
  },
  {
    label: 'Lubes',
    children: [
      { label: 'quantity', value: 'rejectTrips' },
      { label: 'value', value: 'rejectTonnage', formatTo: 'decimal' }
    ]
  },
  {
    label: 'tyres',
    children: [
      { label: 'quantity', value: 'sidingTrips' },
      { label: 'value', value: 'sidingTonnage', formatTo: 'decimal' }
    ]
  },
  {
    label: 'gearAndTransmission',
    children: [
      { label: 'quantity', value: 'totalSrsTrips' },
      { label: 'value', value: 'totalSrsTonnage', formatTo: 'decimal' }
    ]
  },
  {
    label: 'OtherParts',
    children: [
      { label: 'quantity', value: 'otherPartsQuantity' },
      { label: 'value', value: 'otherPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'total',
    children: [{ label: 'value', value: 'totalValue', formatTo: 'decimal' }]
  }
]

export const STORE_PAYLOADER_COLUMNS = [
  { label: 'payloaderRegNo', value: 'sRegistrationNo' },
  { label: 'company', value: 'sShortName' },
  {
    label: 'HSD',
    children: [
      { label: 'quantity', value: 'hsdQuantity' },
      { label: 'value', value: 'hsdValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'Lubes',
    children: [
      { label: 'quantity', value: 'lubesQuantity' },
      { label: 'value', value: 'lubesValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'tyres',
    children: [
      { label: 'quantity', value: 'tyresQuantity' },
      { label: 'value', value: 'tyresValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'filters',
    children: [
      { label: 'quantity', value: 'crownPartsQuantity' },
      { label: 'value', value: 'crownPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'OtherParts',
    children: [
      { label: 'quantity', value: 'otherPartsQuantity' },
      { label: 'value', value: 'otherPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'total',
    children: [{ label: 'value', value: 'totalValue', formatTo: 'decimal' }]
  }
]

export const STORE_OTHER_COLUMNS = [
  { label: 'allOthers', value: 'sRegistrationNo' },
  { label: 'company', value: 'sShortName' },
  {
    label: 'HSD',
    children: [
      { label: 'quantity', value: 'hsdQuantity' },
      { label: 'value', value: 'hsdValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'Lubes',
    children: [
      { label: 'quantity', value: 'lubesQuantity' },
      { label: 'value', value: 'lubesValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'tyres',
    children: [
      { label: 'quantity', value: 'tyresQuantity' },
      { label: 'value', value: 'tyresValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'filters',
    children: [
      { label: 'quantity', value: 'crownPartsQuantity' },
      { label: 'value', value: 'crownPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'OtherParts',
    children: [
      { label: 'quantity', value: 'otherPartsQuantity' },
      { label: 'value', value: 'otherPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'total',
    children: [{ label: 'value', value: 'totalValue', formatTo: 'decimal' }]
  }
]

export const TIPPERS_NO_TABLE_COLUMNS = [
  { label: '', value: 'type' },
  { label: 'tonnageTotal', value: 'tonnageTotal', formatTo: 'decimal' },
  { label: 'noOfDaysOnRoad', value: 'noOfDaysOnRoad' },
  { label: 'noOfTrips', value: 'nTrip' },
  { label: 'avgTripsPerDay', value: 'avgTripsPerDay', formatTo: 'decimal' },
  { label: 'avgTonnagePerTrip', value: 'avgTonnagePerTrip', formatTo: 'decimal' },
  { label: 'avgTonnagePerDay', value: 'avgTonnagePerDay', formatTo: 'decimal' },
  { label: 'amount', value: 'nAmount', formatTo: 'decimal' }
]

export const TIPPERS_NO_LIST_TABLE_COLUMNS = [
  { label: 'date', value: 'dDate' },
  { label: 'company', value: 'sName' },
  { label: 'shiftName', value: 'oShift' },
  { label: 'siteFrom', value: 'oSiteFrom' },
  { label: 'siteTo', value: 'oSiteTo' },
  { label: 'lead', value: ['sFaceLeadKey', 'sSurfaceLeadKey'] },
  { label: 'noOfTrips', value: 'nTrip' },
  { label: 'tonnageTotal', value: 'nWeight', formatTo: 'decimal' },
  { label: 'avgTonnagePerTrip', value: 'avgTonnagePerTrip', formatTo: 'decimal' },
  { label: 'rate', value: 'nRate', formatTo: 'decimal' },
  { label: 'amount', value: 'nAmount', formatTo: 'decimal' }
]

// Store Consumed Tipper Details Table
export const STORE_CONSUMED_TIPPER_NO_COLUMNS = [
  { label: 'date', value: 'dDate' },
  { label: 'company', value: 'sShortName' },
  {
    label: 'HSD',
    children: [
      { label: 'quantity', value: 'hsdQuantity' },
      { label: 'value', value: 'hsdValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'Lubes',
    children: [
      { label: 'quantity', value: 'lubesQuantity' },
      { label: 'value', value: 'lubesValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'tyres',
    children: [
      { label: 'quantity', value: 'tyresQuantity' },
      { label: 'value', value: 'tyresValue', formatTo: 'decimal' }
    ]
  },

  {
    label: 'gearAndTransmission',
    children: [
      { label: 'quantity', value: 'crownPartsQuantity' },
      { label: 'value', value: 'crownPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'OtherParts',
    children: [
      { label: 'quantity', value: 'otherPartsQuantity' },
      { label: 'value', value: 'otherPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'TotalStores',
    children: [{ label: 'value', value: 'totalValue', formatTo: 'decimal' }]
  }
]

// Store Consumed Payloader Details Table
export const STORE_CONSUMED_PAYLOADER_NO_COLUMNS = [
  { label: 'date', value: 'dDate' },
  { label: 'company', value: 'sShortName' },
  {
    label: 'HSD',
    children: [
      { label: 'quantity', value: 'hsdQuantity' },
      { label: 'value', value: 'hsdValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'Lubes',
    children: [
      { label: 'quantity', value: 'lubesQuantity' },
      { label: 'value', value: 'lubesValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'tyres',
    children: [
      { label: 'quantity', value: 'tyresQuantity' },
      { label: 'value', value: 'tyresValue', formatTo: 'decimal' }
    ]
  },

  {
    label: 'filters',
    children: [
      { label: 'quantity', value: 'crownPartsQuantity' },
      { label: 'value', value: 'crownPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'OtherParts',
    children: [
      { label: 'quantity', value: 'otherPartsQuantity' },
      { label: 'value', value: 'otherPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'TotalStores',
    children: [{ label: 'value', value: 'totalValue', formatTo: 'decimal' }]
  }
]
// Store Consumed Payloader Details Table
export const STORE_CONSUMED_OTHERS_NO_COLUMNS = [
  { label: 'date', value: 'dDate' },
  { label: 'company', value: 'sShortName' },
  {
    label: 'HSD',
    children: [
      { label: 'quantity', value: 'hsdQuantity' },
      { label: 'value', value: 'hsdValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'Lubes',
    children: [
      { label: 'quantity', value: 'lubesQuantity' },
      { label: 'value', value: 'lubesValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'tyres',
    children: [
      { label: 'quantity', value: 'tyresQuantity' },
      { label: 'value', value: 'tyresValue', formatTo: 'decimal' }
    ]
  },

  {
    label: 'filters',
    children: [
      { label: 'quantity', value: 'crownPartsQuantity' },
      { label: 'value', value: 'crownPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'OtherParts',
    children: [
      { label: 'quantity', value: 'otherPartsQuantity' },
      { label: 'value', value: 'otherPartsValue', formatTo: 'decimal' }
    ]
  },
  {
    label: 'TotalStores',
    children: [{ label: 'value', value: 'totalValue', formatTo: 'decimal' }]
  }
]

export const rowLabelMap = {
  oStock: 'Stockyard',
  oSiding: 'Siding',
  oReject: 'Reject',
  oTotal: 'Total'
}

export const PAYLOADERS_TABLE_COLUMNS = [
  { label: 'company', value: 'sCompanyShortName' },
  { label: 'payloaderRegNo', value: 'sVehicle' },
  { label: 'shiftName', value: 'sShift' },
  { label: 'noOfHoursEngaged', value: 'nHour' },
  { label: 'tonnageTotal', value: 'nTonnage', formatTo: 'decimal' },
  { label: 'avgTonnagePerHour', value: 'nTonnageHour', formatTo: 'decimal' }
  // { label: 'avgTonnagePerDay', value: 'nTonnageDay', formatTo: 'decimal' }
]

export const PAYLOADER_NO_TABLE_COLUMNS = [
  { label: 'company', value: 'sName' },
  { label: 'noOfHours', value: 'nHour' },
  { label: 'tonnageTotal', value: 'nTonnage', formatTo: 'decimal' },
  { label: 'avgTonnagePerHour', value: 'nTonnageHour', formatTo: 'decimal' },
  { label: 'avgTonnagePerDay', value: 'nAvgTonnageDay', formatTo: 'decimal' },
  { label: 'rate', value: 'nRate', formatTo: 'decimal' },
  { label: 'amount', value: 'nAmount', formatTo: 'decimal' }
]

export const PAYLOADER_NO_LIST_TABLE_COLUMNS = [
  { label: 'date', value: 'dDate' },
  { label: 'site', value: 'oSite' },
  { label: 'shiftName', value: 'oShift' },
  { label: 'operatorName', value: 'oEmployee' },
  { label: 'tonnageTotal', value: 'nWeight', formatTo: 'decimal' },
  { label: 'avgTonnagePerHour', value: 'avgTonnagePerTrip', formatTo: 'decimal' },
  { label: 'rate', value: 'nRate', formatTo: 'decimal' },
  { label: 'amount', value: 'nAmount', formatTo: 'decimal' }
]

export const EQUIPMENT_TABLE_COLUMNS = [
  { label: 'company', value: 'sName' },
  { label: 'equipmentVehicleType', value: 'eType' },
  { label: 'quantity/Number', value: 'nCount', formatTo: 'decimal' }
]

export const EQUIPMENT_RENEWALS = [
  { value: 'nInsurance', label: 'insuranceRenewalPending', type: 'insurance' },
  { value: 'nFitness', label: 'fitnessRenewalPending', type: 'fitness' },
  { value: 'nPUC', label: 'PUCRenewalPending', type: 'puc' },
  { value: 'nPermit', label: 'permitRenewalPending', type: 'permit' }
]

export const SORT_OPTS_EQUIPMENT_RENEWALS = [
  { label: 'Vehicle Type (↑ A-Z)', value: { sort: 'eType', order: 'asc' } },
  { label: 'Vehicle Type (↓ Z-A)', value: { sort: 'eType', order: 'dsc' } },
  { label: 'Vehicle Reg. No. (↑ 1-10)', value: { sort: 'sRegistrationNo', order: 'asc' } },
  { label: 'Vehicle Reg. No. (↓ 10-1)', value: { sort: 'sRegistrationNo', order: 'dsc' } }
]

export const SORT_OPTS_HRADMIN_RENEWALS = [
  { label: 'Employee ID (↑ 1-10)', value: { sort: 'nIdCard', order: 'asc' } },
  { label: 'Employee ID (↓ 10-1)', value: { sort: 'nIdCard', order: 'dsc' } },
  { label: 'Name (↑ A-Z)', value: { sort: 'sName', order: 'asc' } },
  { label: 'Name (↓ Z-A)', value: { sort: 'sName', order: 'dsc' } }
]

export const DESIGNATION_LIST_TABLE_COLUMNS = [
  { label: 'totalManpower', value: 'nTotal' },
  { label: 'tipperDrivers', value: 'nTipperDriver' },
  { label: 'payLoaderOperators', value: 'nPayLoaderOperator' },
  { label: 'supervisors', value: 'nSupervisor' },
  { label: 'munshis', value: 'nMunshis' },
  { label: 'payLoaderMechanics', value: 'nPayLoaderMechanic' },
  { label: 'workshopMechanics', value: 'mWorkshopMechanics' },
  { label: 'stores', value: 'nStore' },
  { label: 'LMVDrivers', value: 'nLMVDrivers' },
  { label: 'security', value: 'nSecurity' },
  { label: 'others', value: 'nOther' }
]

// ? Download feature mapping values
// Column mappings for each report type
export const COLUMN_MAPPINGS = {
  'production-tippers': {
    Company: 'oCompany.sShortName',
    'Tipper Registration No.': 'oVehicle.sRegistrationNo',
    'Shift ': 'oShift.sName',
    'Stockyard No. of Trips': 'oStock.nTrip',
    'Stockyard Tonnage': 'oStock.nTonnage',
    'Stockyard Tonnage/Trip': 'oStock.nAvgTonnage',
    'Reject No. of Trips': 'oReject.nTrip',
    'Reject Tonnage': 'oReject.nTonnage',
    'Reject Tonnage/Trip': 'oReject.nAvgTonnage',
    'Siding No. of Trips': 'oSiding.nTrip',
    'Siding Tonnage': 'oSiding.nTonnage',
    'Siding Tonnage/Trip': 'oSiding.nAvgTonnage',
    'Total SRS No. of Trips': 'oTotal.nTrip',
    'Total Srs Tonnage': 'oTotal.nTonnage',
    'Total SRS Tonnage/Trip': 'oTotal.nAvgTonnage',
    'Revenue ': 'nAmount'
  },
  'production-payloaders': {
    Company: 'sCompany',
    'Payloader Registration No.': 'sVehicle',
    'Shift ': 'sShift',
    'No. of Hours Engaged': 'nHour',
    'Tonnage Total': 'nTonnage',
    'Avg. Tonnage/Hour': 'nTonnageHour'
  },
  'tipper-no': {
    'Date ': 'dDate',
    Company: 'oCompany.sName',
    'Shift ': 'oShift.sName',
    'From Name of Face': 'oSiteFrom.sName',
    'To Destination': 'oSiteTo.sName',
    'Lead ': (item) => item?.sFaceLeadKey + item?.sSurfaceLeadKey,
    'No. of Trips': 'nTrip',
    'Tonnage Total': 'nWeight',
    'Avg. Tonnage/Trip': 'avgTonnagePerTrip',
    'Rate(Rs.)': 'nRate',
    'Amount(Rs.)': 'nAmount'
  },
  'payloader-no': {
    'Date ': 'dDate',
    // 'Payloader No': 'oVehicle.sRegistrationNo',
    // 'Vehicle Short Name': 'oVehicle.sShortName',
    Site: 'oSite.sName',
    // 'Company Name': 'oCompany.sName',
    Shift: 'oShift.sName',
    'Operator Name': 'oEmployee.sName',
    'Tonnage Total': 'nWeight',
    'Avg. Tonnage/Hour': 'avgTonnagePerTrip',
    'Rate(Rs.)': 'nRate',
    'Amount(Rs.)': 'nAmount'
  },
  // 'stores-consumed-tippers' is handled dynamically: columns depend on the
  // categories present in the API response, so `useDownloadData` returns rows
  // already keyed by display column names and `createTransformData` derives
  // the header from those keys.
  // Matches the on-screen `STORE_PAYLOADER_COLUMNS` table: registration +
  // company + HSD / Lubes / Tyres / Filters / Other Spare Parts (each with
  // Quantity + Value (Rs.)) + Total Value (Rs.). Header strings mirror the
  // translation values used in the UI.
  'stores-consumed-payloaders': {
    'Payloader Registration No.': 'sRegistrationNo',
    Company: 'sCompanyShortName',
    'HSD Quantity': 'oHSD.nQuantity',
    'HSD Value (Rs.)': 'oHSD.nAmount',
    'Lubes Quantity': 'oLubes.nQuantity',
    'Lubes Value (Rs.)': 'oLubes.nAmount',
    'Tyres Quantity': 'oTyres.nQuantity',
    'Tyres Value (Rs.)': 'oTyres.nAmount',
    'Filters Quantity': 'oCrownParts.nQuantity',
    'Filters Value (Rs.)': 'oCrownParts.nAmount',
    'Other Spare Parts Quantity': 'oOther.nQuantity',
    'Other Spare Parts Value (Rs.)': 'oOther.nAmount',
    'Total Value (Rs.)': 'nTotalAmount'
  },
  // 'stores-consumed-other' is handled dynamically: the on-screen table is
  // built with `FIXED_CATEGORY_ORDER` (15 categories), so `useDownloadData`
  // returns rows already keyed by display column names and
  // `createTransformData` derives the header from those keys.
  // Matches the on-screen detail table (`TIPPER_NO_PARTS_COLUMNS`). The data
  // fed to this mapping is the result of `flattenConsumedTipperRows`, so one
  // CSV row per part with already-formatted `dDate`.
  'stores-consumed-tipper-no': {
    Date: 'dDate',
    Company: 'sShortName',
    'Part Name': 'sPartName',
    Category: 'sCategory',
    Quantity: 'nQuantity',
    'Price per Unit (Rs.)': 'nRate',
    'Total Cost (Rs.)': 'nAmount'
  },
  // Matches the on-screen `PAYLOADER_NO_PARTS_COLUMNS` table. Source rows
  // come from `flattenConsumedTipperRows`, which yields one row per part
  // with an already-formatted `dDate`.
  'stores-consumed-payloader-no': {
    Date: 'dDate',
    Company: 'sShortName',
    'Part Name': 'sPartName',
    Category: 'sCategory',
    Quantity: 'nQuantity',
    'Price per Unit (Rs.)': 'nRate',
    'Total Cost (Rs.)': 'nAmount'
  },
  // Matches the on-screen `ALL_OTHERS_NO_PARTS_COLUMNS` table. Source rows
  // come from `flattenConsumedTipperRows`, which yields one row per part
  // with an already-formatted `dDate`.
  'stores-consumed-other-no': {
    Date: 'dDate',
    Company: 'sShortName',
    'Part Name': 'sPartName',
    Category: 'sCategory',
    Quantity: 'nQuantity',
    'Price per Unit (Rs.)': 'nRate',
    'Total Cost (Rs.)': 'nAmount'
  }
}

// ? File name mappings
export const FILE_NAMES = {
  'production-tippers': 'production-tippers',
  'production-payloaders': 'production-payloaders',
  'tipper-no': 'tipper-no',
  'payloader-no': 'payloader-no',
  'stores-consumed-tippers': 'stores-consumed-tippers',
  'stores-consumed-payloaders': 'stores-consumed-payloaders',
  'stores-consumed-other': 'stores-consumed-other',
  'stores-consumed-tipper-no': 'stores-consumed-tipper-no',
  'stores-consumed-payloader-no': 'stores-consumed-payloader-no',
  'stores-consumed-other-no': 'stores-consumed-other-no'
}

export const EQUIPMENT_DEPLOYMENT_TABS = [
  { name: 'tipper', value: 'tipper' },
  { name: 'payloader', value: 'payloader' }
]

export const absenceTypes = [
  { label: 'Full Day (8 hours)', value: 'FULL' },
  { label: 'First Half (First 4 hours)', value: 'FIRST_HALF' },
  { label: 'Second Half (Second 4 hours)', value: 'SECOND_HALF' }
]

export const statusTypes = [
  { label: 'Idle', value: 'Idle' },
  { label: 'On Road', value: 'On Road' },
  { label: 'In Workshop', value: 'In Workshop' }
]

// Column definitions for StoresTable
export const STORE_DATA_COLUMNS = [
  { label: 'description', value: 'description' },
  {
    label: 'openingStock',
    children: [
      { label: 'quantity', value: 'openingQuantity' },
      { label: 'value', value: 'openingValue', formatTo: 'currency' }
    ]
  },
  {
    label: 'purchase',
    children: [
      { label: 'quantity', value: 'purchaseQuantity' },
      { label: 'value', value: 'purchaseValue', formatTo: 'currency' }
    ]
  },
  {
    label: 'stockIssued',
    children: [
      { label: 'quantity', value: 'issuedQuantity' },
      { label: 'value', value: 'issuedValue', formatTo: 'currency' }
    ]
  },
  {
    label: 'closingStock',
    children: [
      { label: 'quantity', value: 'closingQuantity' },
      { label: 'value', value: 'closingValue', formatTo: 'currency' }
    ]
  }
]
// Inventory Types
export const inventoryTypes = [
  { key: 'oTotal', description: 'Total' },
  { key: 'oHSD', description: 'HSD' },
  { key: 'oTyres', description: 'Tyres' },
  { key: 'oLubes', description: 'Lubes' },
  { key: 'oCrown', description: 'Gear & Transmission' },
  { key: 'oBATTERY', description: 'Battery' },
  { key: 'oDIFFERENTIAL', description: 'Differential' },
  { key: 'oELECTRICAL', description: 'Electrical' },
  { key: 'oENGINE', description: 'Engine' },
  { key: 'oHYDRAULIC', description: 'Hydraulic' },
  { key: 'oMISCELLANEOUS', description: 'Miscellaneous' },
  { key: 'oRepairedProducts', description: 'Repaired Product' },
  { key: 'oRUNNINGCOMMON', description: 'Running Common' },
  { key: 'oSECONDHANDREFURBISHED', description: 'Second Hand Refurbished' },
  { key: 'oSUSPENSION', description: 'Suspension' },
  { key: 'oTUBES&PATCH', description: 'Tubes & Patch' }
]
